import React, { Component } from 'react';
import { View, FlatList } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  Types,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import { PaymentFooter } from '../../../Payment';
import AddPaymentCard from '../../../Payment/Containers/AddPaymentCard';
import { PaymentScreenTypes } from '../../../Payment/Utils/PaymentTypes';
import Loading from '../Loading';
import Option from '../Option';

import styles from './AddDataSelector.styles';

const sections = {
  paymentType: 'payment type',
  paymentAmount: 'payment amount',
};

class AddDataSelector extends Component {
  constructor(props) {
    super(props);
    this.scrollViewRef = React.createRef();
  }

  state = {
    paymentTypeOptionSelected: 1,
    paymentAmountOptionSelected: -1,
  };

  componentDidMount() {
    !this.props.isLoadingSuccessful && this.setSelectedOptions();
    const timeOut = new Promise(resolve => setTimeout(resolve, 500));
    timeOut.then(() => {
      this.scrollViewRef.current.scrollToIndex({
        index:
          this.state.paymentAmountOptionSelected !== -1 &&
          this.state.paymentAmountOptionSelected - 1,
        animated: false,
      });
    });
  }
  onLayout = ({ nativeEvent }) => {
    this.props.getModalHeight(nativeEvent.layout.height);
  };

  selectOption = (index, section) => {
    const { selectPaymentTypeOption, selectPaymentAmountOption } = this.props;
    if (section === sections.paymentType) {
      this.setState({
        paymentTypeOptionSelected: index + 1,
      });
      this.state.paymentTypeOptionSelected !== index + 1 &&
        this.setState({
          paymentAmountOptionSelected: -1,
        });
      selectPaymentTypeOption(index);
    } else if (section === sections.paymentAmount) {
      this.setState({
        paymentAmountOptionSelected: index + 1,
      });
      selectPaymentAmountOption(index);
    }
  };

  handlePaymentAmount = options => {
    if (options && options.length > 0) {
      let style = {};
      if (options.length === 1) {
        style = styles.oneOptionStyle;
      } else if (options.length === 2) {
        style = styles.twoOptionStyle;
      } else if (options.length === 3) {
        style = styles.threeOptionStyle;
      } else if (options.length > 3) {
        style = styles.moreThanThreeOptionsStyle;
      }
      if (options.length <= 3) {
        return (
          <View style={styles.paymentAmountOptionsContainer}>
            {this.renderSectionOptions(options, sections.paymentAmount, style)}
          </View>
        );
      } else if (options.length > 3) {
        return (
          <FlatList
            ref={this.scrollViewRef}
            horizontal
            contentContainerStyle={styles.moreThanThreeOptionsContainer}
            showsHorizontalScrollIndicator={false}
            bounces={false}
            data={this.renderSectionOptions(options, sections.paymentAmount, style)}
            renderItem={({ item }) => item}
            onScrollToIndexFailed={() => {}}
          />
        );
      }
    }
  };

  handleConfirmButtonPress = () => {
    const { handleConfirmButtonPress, paymentTypeOptions, paymentAmountOptions } = this.props;
    handleConfirmButtonPress(
      paymentTypeOptions[this.state.paymentTypeOptionSelected - 1],
      paymentAmountOptions[this.state.paymentAmountOptionSelected - 1],
    );
  };

  setSelectedOptions = () => {
    const selectedOptions = this.props.setSelectedOptions() || {};
    this.setState({
      paymentTypeOptionSelected: selectedOptions.paymentOption,
      paymentAmountOptionSelected: selectedOptions.paymentAmount,
    });
  };

  renderOption = (option, section, index, style, theme) => {
    const { paymentTypeOptionSelected, paymentAmountOptionSelected } = this.state;
    const { title, subTitle } = option;
    const isActive =
      section === sections.paymentType
        ? index === paymentTypeOptionSelected - 1
        : index === paymentAmountOptionSelected - 1;
    return (
      <Option
        key={index}
        mainTitle={title}
        mainTitleTextStyle={styles.mainTitleTextStyle(theme, isActive, subTitle)}
        subTitle={subTitle}
        subTitleTextStyle={styles.subTitleTextStyle(theme, isActive)}
        isActive={isActive}
        index={index}
        selectOption={optionIndex => this.selectOption(optionIndex, section)}
        containerStyle={style}
      />
    );
  };

  renderSectionOptions = (options, section, style) => {
    const { theme } = this.props;
    const displayedOptions = _map(options, (option, index) => {
      return this.renderOption(option, section, index, style, theme);
    });
    return displayedOptions;
  };
  renderLoading = () => {
    const { loadingMessage, loadingMessageTextStyle, loadingLottieViewStyle, modalHeight } =
      this.props;

    return (
      <Loading
        autoPlay
        loop
        loadingMessage={loadingMessage}
        loadingMessageTextStyle={loadingMessageTextStyle}
        modalHeight={modalHeight}
        loadingLottieViewStyle={loadingLottieViewStyle}
      />
    );
  };

  renderAddDataSelector() {
    const {
      paymentTypeSectionContainerStyle,
      theme,
      paymentTypeTitleStyle,
      paymentTypeTitle,
      paymentTypeOptions,
      paymentAmountContainerStyle,
      paymentAmountTitleStyle,
      paymentAmountTitle,
      paymentAmountOptions,
      isPaymentMethod,
      renderCustomPaymentMethod,
      paymentFooterIcon,
      handlePaymentFooterIconPress,
      paymentFooterDescription,
      footerDescriptionStyle,
      confirmButtonType,
      confirmButtonTitle,
      cancelButtonType,
      cancelButtonTitle,
      handleCancelButtonPress,
      paymentCards,
      defaultPayment,
      onSelectDefaultCard,
      onPressOpenCardList,
      paymentOptions,
      onPressAddCard,
      btnsContainerStyle,
    } = this.props;
    return (
      <>
        <View style={[styles.paymentTypeSecionContainer, paymentTypeSectionContainerStyle]}>
          <VFText
            style={[styles.sectionTitle(theme), paymentTypeTitleStyle]}
            i18nKey={paymentTypeTitle}
          />
          <View style={styles.paymentTypeOptionsContainer}>
            {this.renderSectionOptions(
              paymentTypeOptions,
              sections.paymentType,
              styles.twoOptionStyle,
            )}
          </View>
        </View>
        <View style={[styles.paymentAmountContainer, paymentAmountContainerStyle]}>
          <VFText
            style={[styles.amountSectionTitle(theme), paymentAmountTitleStyle]}
            i18nKey={paymentAmountTitle}
          />
          {this.handlePaymentAmount(paymentAmountOptions)}
        </View>

        <PaymentFooter
          isPaymentMethod={isPaymentMethod}
          renderCustomPaymentMethod={renderCustomPaymentMethod}
          icon={paymentFooterIcon}
          handleIconPress={handlePaymentFooterIconPress}
          description={paymentFooterDescription}
          descriptionStyle={[styles.paymentMethodDescriptionStyle(theme), footerDescriptionStyle]}
          btnSuccessType={confirmButtonType}
          btnSuccessTitle={confirmButtonTitle}
          onSuccessBtnPress={this.handleConfirmButtonPress}
          btnSuccessTextStyle={styles.confirmButtonTextStyle(theme)}
          isBtnSuccessDisabled={this.state.paymentAmountOptionSelected === -1}
          successBtnDisabledStyle={styles.successBtnDisabled(theme)}
          successBtnDisabledTextStyle={styles.successBtnDisabledText(theme)}
          successBtnTheme={{}}
          hasMoreBtns
          btnRejectType={cancelButtonType}
          btnRejectTitle={cancelButtonTitle}
          onRejectBtnPress={handleCancelButtonPress}
          btnRejectTextStyle={styles.cancelButtonTextStyle(theme)}
          paymentCards={paymentCards}
          defaultPayment={defaultPayment}
          onSelectDefaultCard={onSelectDefaultCard}
          onOpenCardList={onPressOpenCardList}
          isCardListOpend={paymentOptions.isCardListOpend}
          onAddCard={onPressAddCard}
          btnsContainerStyle={btnsContainerStyle}
        />
      </>
    );
  }

  renderAddPaymentCard() {
    const { onPressSaveCard, theme } = this.props;
    return (
      <AddPaymentCard
        title={'quick_action_add_new_payment_card_subtitle'}
        cardNumberLabel={'quick_action_add_new_payment_card_field_card_number'}
        nameOnCardLabel={'quick_action_add_new_payment_card_field_name_on_card'}
        expirationDateLabel={'quick_action_add_new_payment_card_field_expire_date'}
        expirationDateFormatLabel={'quick_action_add_new_payment_card_expiration_date_hint_message'}
        cvvNumberLabel={'quick_action_add_new_payment_card_field_cvv'}
        cardNameLabel={'quick_action_add_new_payment_card_field_card_name'}
        saveCardText={'quick_action_add_new_payment_card_save_this_card'}
        secureText={'quick_action_add_new_payment_card_encryption_hint'}
        primaryButtonText={'quick_action_add_new_payment_card_done'}
        inputContainerStyle={styles.inputContainer}
        halfSizeContainerStyle={styles.halfSizeContainer}
        secureTextStyle={styles.secureText(theme)}
        isSecureIcon={false}
        isSecureContainerBottomBorder
        onPressSaveCard={onPressSaveCard}
        contentContainerStyle={styles.addCardContainerStyle}
      />
    );
  }

  render() {
    const { isLoadingVisible, paymentOptions } = this.props;
    return (
      <View style={styles.container} onLayout={this.onLayout}>
        {isLoadingVisible
          ? this.renderLoading()
          : paymentOptions.screen === PaymentScreenTypes.ADD_PAYMENT_CARD
          ? this.renderAddPaymentCard()
          : this.renderAddDataSelector()}
      </View>
    );
  }
}

AddDataSelector.defaultProps = {
  setSelectedOptions: () => {},
  paymentTypeOptions: [],
  paymentAmountOptions: [],
  handlePaymentFooterIconPress: () => {},
  confirmButtonType: Types.PRIMARY,
  handleConfirmButtonPress: () => {},
  cancelButtonType: Types.SECONDARY,
  handleCancelButtonPress: () => {},
  theme: LightThemeColors,
  isPaymentMethod: true,
};

AddDataSelector.propTypes = {
  defaultPayment: PropTypes.object,
  onSelectDefaultCard: PropTypes.func,
  onPressOpenCardList: PropTypes.func,
  paymentOptions: PropTypes.object,
  onPressAddCard: PropTypes.func,
  onPressSaveCard: PropTypes.func,
  isLoadingSuccessful: PropTypes.bool,
  setSelectedOptions: PropTypes.func,
  paymentTypeTitle: PropTypes.string,
  paymentTypeTitleStyle: ViewPropTypes.style,
  paymentTypeOptions: PropTypes.array,
  selectPaymentTypeOption: PropTypes.func,
  paymentAmountTitle: PropTypes.string,
  paymentAmountTitleStyle: ViewPropTypes.style,
  paymentAmountOptions: PropTypes.array,
  selectPaymentAmountOption: PropTypes.func,

  paymentFooterIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
    }),
  ]),
  handlePaymentFooterIconPress: PropTypes.func,
  paymentFooterDescription: PropTypes.string,
  confirmButtonType: PropTypes.string,
  confirmButtonTitle: PropTypes.string,
  handleConfirmButtonPress: PropTypes.func,
  cancelButtonType: PropTypes.string,
  cancelButtonTitle: PropTypes.string,
  handleCancelButtonPress: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  getModalHeight: PropTypes.func,
  paymentCards: PropTypes.arrayOf(
    PropTypes.shape({
      brand: PropTypes.string,
      lastFourDigits: PropTypes.string,
      cardName: PropTypes.string,
      expiry: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }),
  ),
  isPaymentMethod: PropTypes.bool,
  renderCustomPaymentMethod: PropTypes.func,
  footerDescriptionStyle: TextPropTypes.style,
  paymentTypeSectionContainerStyle: ViewPropTypes.style,
  paymentAmountContainerStyle: ViewPropTypes.style,
  btnsContainerStyle: ViewPropTypes.style,
  loadingLottieViewStyle: ViewPropTypes.style,
  isLoadingVisible: PropTypes.bool,
  loadingMessage: PropTypes.string,
  loadingMessageTextStyle: TextPropTypes.style,
  modalHeight: PropTypes.number,
};

export default withTheme(AddDataSelector);
